import React from "react";
import { Children } from "react";

export default function SearchInputWrap({ className, children }) {
    return (
        <div className={className}>
            {children}
        </div>
    )
}